import React, { useState } from 'react';
import { Input } from 'antd';
import _commonService from '../modules/commonService';

// Shows only the last 4 characters when the field isn't focused (e.g. "*********1010"),
// for SSN/ITIN and ID Number entry. The Form value itself always stays the full raw
// string (used for validation/submission) — masking is a display-only transform that's
// lifted while the field is focused so the user can see what they're typing/editing.
const MaskedDigitsInput = ({ value, onFocus, onBlur, ...rest }) => {
    const [isFocused, setIsFocused] = useState(false);

    const displayValue = isFocused || !value ? value : _commonService.maskLast4Digits(value);

    return (
        <Input
            {...rest}
            value={displayValue}
            onFocus={(e) => {
                setIsFocused(true);
                if (onFocus) onFocus(e);
            }}
            onBlur={(e) => {
                setIsFocused(false);
                if (onBlur) onBlur(e);
            }}
        />
    );
};

export default MaskedDigitsInput;
